import { observer } from 'mobx-react';

const LeaderboardUserInfo = observer(({ user }) => (
  <li className='infinite-item flex items-center mr-1'>
    <p className='h80 index text-grey-50 text-center'>
      {`${user.rank || '--'}`}
    </p>

    <div dangerouslySetInnerHTML={{ __html: user.avatarUrl }} />

    <div className='user-info flex flex-col'>
      <div className='flex text-xs'>
        <a className='text-cw-black font-bold underline' href={`/${user.slug}`}>
          {user.fullName}
        </a>
      </div>

      {user.showAmount && (
        <div className='flex items-center'>
          {user.showCurrencyConverter && (
            <span
              aria-label={`Converted from ${user.currencyUnit}${user.currencyName}`}
              className='tooltipped tooltipped-ne tooltipped-no-delay tooltipped-multiline'
            >
              <span className='cw-icon-loop currency-converter' />
            </span>
          )}
          <p className='amount-raised text-cw-green font-bold m-0'>
            {user.formattedAmount}
          </p>
        </div>
      )}
    </div>
  </li>
));

export default LeaderboardUserInfo;
